module.exports = __webpack_public_path__ + "img/attach.b298a751.svg";